import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import {
  Container,
  Card,
  Grid,
  Box,
  Typography,
  CardActions,
  Button,
  Breadcrumbs,
  Modal,
} from "@mui/material";
import { instanceToken } from "../../../utils/constant";
import userManualService from "../../../services/userManual";
const styleR = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const DetailUserManual = ({ homeAlert }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [partner, setPartner] = useState(null);
  const [openR, setOpenR] = useState(false);

  useEffect(() => {
    if (!partner) {
      fetchPartner();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchPartner = async () => {
    try {
      const res = await userManualService.getUserManual(
        instanceToken.token,
        id
      );
      console.log("res ", res);
      setPartner(res.data);
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  };

  if (!partner) {
    return <em>Loading...</em>;
  }

  const handleOpenR = () => setOpenR(true);
  const handleCloseR = () => setOpenR(false);
  const handleRemove = async () => {
    try {
      await userManualService.deleteUserManual(instanceToken.token, id);
      homeAlert("User Manual have been removed.", false);
      navigate("/user-manual");
    } catch (error) {
      console.log(error);
      homeAlert("Error on server!", true);
    }
  };

  return (
    <>
      <div role="presentation">
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" to="/faqs">
            User Manual
          </Link>
          <Typography color="text.primary">User Manual (ID - {id})</Typography>
        </Breadcrumbs>
      </div>
      <Container
        maxWidth={false}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          mt: 2,
        }}
      >
        <Card
          sx={{
            minWidth: "80vw",
            minHeight: "60vh",
            display: "flex",
            flexDirection: "column",
            // gridTemplateColumns: "2fr 3fr",
          }}
        >
          <Box
            sx={{
              ml: 2,
              p: 2,
              // bgcolor: "#f7f7f5",
              borderRadius: 2,
            }}
          >
            {/* Name MM */}
            <Grid sx={{ m: 2 }} container spacing={2}>
              <Grid item xs={2}>
                <Typography variant="body2" color="text.secondary">
                  Title Eng
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="body2" color="text.secondary">
                  {partner.question_en}
                </Typography>
              </Grid>
            </Grid>

            {/* Name MM */}
            <Grid sx={{ m: 2 }} container spacing={2}>
              <Grid item xs={2}>
                <Typography variant="body2" color="text.secondary">
                  Title MM
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="body2" color="text.secondary">
                  {partner.question_mm}
                </Typography>
              </Grid>
            </Grid>

            {/* Address MM */}
            <Grid sx={{ m: 2 }} container spacing={2}>
              <Grid item xs={2} sx={{ mt: 2 }}>
                <Typography variant="body2" color="text.secondary">
                  Answers
                </Typography>
              </Grid>

              <Grid item xs={8}>
                {partner.answers.map((d, index) => (
                  <Box
                    key={index}
                    style={{ borderBottom: "1px solid black" }}
                    sx={{ my: 2 }}
                  >
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      style={{ marginBottom: "15px" }}
                    >
                      - {d?.answer_en}
                    </Typography>
                    <Typography
                      key={index}
                      variant="body2"
                      color="text.secondary"
                      style={{ marginBottom: "15px" }}
                    >
                      {"  "} - {d?.answer_mm}
                    </Typography>
                  </Box>
                ))}
              </Grid>
            </Grid>

            {/* email */}
            <Grid sx={{ m: 2 }} container spacing={2}></Grid>
          </Box>

          <CardActions sx={{ gridColumn: "1/3", justifyContent: "end" }}>
            <Button
              sx={{ m: "1rem" }}
              variant="contained"
              color="error"
              onClick={handleOpenR}
            >
              Remove
            </Button>
            <Button
              size="small"
              component={Link}
              variant="contained"
              to={`/user-manual/update/${partner.id}`}
            >
              Edit
            </Button>
          </CardActions>
        </Card>
      </Container>
      <Modal
        keepMounted
        open={openR}
        onClose={handleCloseR}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box sx={styleR}>
          <Typography id="keep-mounted-modal-title" variant="h6" component="h2">
            Confirmation
          </Typography>
          <Typography id="keep-mounted-modal-description" sx={{ mt: 2 }}>
            Are you sure want to remove it?
          </Typography>
          <Box sx={{ textAlign: "right", mt: 2 }}>
            <Button color="secondary" onClick={handleCloseR}>
              Cancel
            </Button>
            <Button onClick={handleRemove}>Confirm</Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DetailUserManual;
